import React, { useEffect } from 'react';

interface LogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  userName?: string;
  userRole?: string;
}

const LogoutModal: React.FC<LogoutModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  userName = 'User',
  userRole = 'User'
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="logout-modal-overlay" onClick={handleBackdropClick}>
      <div className="logout-modal">
        <div className="logout-modal-header">
          <div className="logout-icon">🚪</div>
          <h3>Confirm Logout</h3>
        </div>
        
        <div className="logout-modal-content">
          <p>Are you sure you want to logout?</p>
          <div className="user-info">
            <span className="user-name">{userName}</span>
            <span className="user-role">({userRole})</span>
          </div>
          <p className="logout-warning">
            You will be redirected to the login page and will need to sign in again.
          </p>
        </div>
        
        <div className="logout-modal-actions">
          <button className="btn-cancel" onClick={onClose}>
            <span className="btn-icon">❌</span>
            Cancel
          </button>
          <button className="btn-confirm-logout" onClick={onConfirm}>
            <span className="btn-icon">🚪</span>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;










